module.exports = __webpack_public_path__ + "623f5ed42b0b347fb4531ded4e4b57a2.woff";